/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from "react";
import ServicesLayout from "../../components/ServicesLayout";
import _ from "lodash";
import {
  fetchPrecints,
  fetchMapState,
  checkCertificates,
} from "../../lib/utils";
import EPUAPCertNotFound from "../ePUAPNotFound/ePUAPCertNotFound";
import WKCertNotFound from "../WKNotFound/WKCertNotFound"
import NotFound from '../notFound/NotFound';

import EServices from "./EServices.js";
import CreatedEservice from "./CreatedEservice.js";
import DecyzjeWZ from "./DecyzjeWZ";
import UsuniecieDrzew from "./UsuniecieDrzew";

import SporzadzenieMPZP from "./SporzadzenieMPZP";
import ZezwolenieAlkohol from "./ZezwolenieAlkohol";
import ZmianaCeluPublicznego from "./ZmianaCeluPublicznego";
import ZmianaMPZP from "./ZmianaMPZP";
import UstalenieNumeruPorzadkowego from "./UstalenieNumeruPorzadkowego";
import OplataPlanistyczna from "./OplataPlanistyczna";
import DecyzjeULICP from "./DecyzjeULICP";
import DecyzjaSrodowiskowa from "./DecyzjaSrodowiskowa";
import DeklaracjaGrobu from "./DeklaracjaGrobu";
import ZaswiadczenieEMUIA from "./ZaswiadczenieEMUIA.js";
import ServiceWMSWFS from "./ServiceWMSWFS";
import InvestContact from "./InvestContact";
import InvestContactForm from "./InvestContactForm";
import ZmianaWarunkowZabudowy from "./ZmianaWarunkowZabudowy";
import ZmianaWZ from "./ZmianaWZ";
import PrzeniesienieWZ from "./PrzeniesienieWZ";
import WnOpiniaPodzialu from "./WnOpiniaPodzialu";
import ZgloszenieEwPOS from "./ZgloszenieEwPOS";
import ZmianaSUIKZP from "./ZmianaSUIKZP";
import PrzeniesienieSrodowiskowychUwarunkowan from "./PrzeniesienieSrodowiskowychUwarunkowan";
import LudnoscMiejscowosc from "./LudnoscMiejscowosc";
import LudnoscUlica from "./LudnoscUlica";
import OdpadyInfo from "./OdpadyInfo";
import DzierzawaNieruchomosci from "./DzierzawaNieruchomosci";
import OpiniaPodzialu from "./OpiniaPodzialu";
import ZaswiadczenieFormOchrony from "./ZaswiadczenieFormOchrony";
import WniosekPomnikPrzyrody from "./WniosekPomnikPrzyrody";
import UwagiProceduryPlanistycznej from "./UwagiProceduryPlanistycznej";
import SprzedazNieruchomosci from "./SprzedazNieruchomosci";
import ZgodnoscMPZP from "./ZgodnoscMPZP";
import ZgodnoscBudowy from "./ZgodnoscBudowy";
import WniosekUproszczonyWypis from "./WniosekUproszczonyWypis";
import ZgloszeniePOS from "./ZgloszeniePOS";
import PrzeniesienieDecyzjiOWarunkachZabudowy from "./PrzeniesienieDecyzjiOWarunkachZabudowy";
import LinkRedirector from "./LinkRedirector";
import WniosekMiejsceNaCmentarzu from "./WniosekMiejsceNaCmentarzu";
import PrzedlDzierBudGosp from "./PrzedlDzierBudGosp";
import PrzedDzierGrunty from "./PrzedDzierGrunty";
import DzierGruntRolnych from "./DzierGruntRolnych";
import WykrHipoteki from "./WykrHipoteki";
import PrzeniesienieCeluPublicznego from "./PrzeniesienieCeluPublicznego";
import UzgodnienieBudowyOgrodzenia from "./UzgodnienieBudowyOgrodzenia";
import ZwolnieniePasaDrogowego from "./ZwolnieniePasaDrogowego";
import NaliczenieOplatyRocznej from "./NaliczenieOplatyRocznej";
import WniosekUzytkownikaWieczystego from "./WniosekUzytkownikaWieczystego";
import ZajeciePasaDrogowego from "./ZajeciePasaDrogowego";
import PrzydzialLokaluMieszkalnego from "./PrzydzialLokaluMieszkalnego";
import SprzedazGruntuPodGaraz from "./SprzedazGruntuPodGaraz";
import SprzedazGruntuNaRzeczWUzytkownika from "./SprzedazGruntuNaRzeczWUzytkownika";
import ZmianaAdrDoKorespondencji from "./ZmianaAdrDoKorespondencji";
import NabycieNieruchomosciBezPrzetargu from "./NabycieNieruchomosciBezPrzetargu";
import ZbycieNieruchomosciWPrzetargu from "./ZbycieNieruchomosciWPrzetargu";
import OddanieNieruchomosci from "./OddanieNieruchomosci";
import RozgraniczenieNieruchomosci from "./RozgraniczenieNieruchomosci";
import DzierzawaGruntowRolnych from "./DzierzawaGruntowRolnych";
import PrzeksztalceniePrawaUzytkowania from "./PrzeksztalceniePrawaUzytkowania";
import WydanieDecyzjiWZ from "./WydanieDecyzjiWZ";
import WydanieDecyzjiULICP from "./WydanieDecyzjiULICP";
import PrzekroczenieTonazu from "./PrzekroczenieTonazu";
import PismoDoAktu from "./PismoDoAktu";
import ObciazanieNieruchomosci from "./ObciazanieNieruchomosci";
import OplataRoczna from "./OplataRoczna";
import UwagaMPZP from "./UwagaMPZP";
import DecyzjeWZiULICP from "./DecyzjeWZiULICP";
import ZgloszenieUsunieciaDrzew from "./ZgloszenieUsunieciaDrzew";
import WydanieNagranZMonitoringu from "./WydanieNagranZMonitoringu";
import ZbycieNieruchomosciKomunalnej from "./ZbycieNieruchomosciKomunalnej";
import RozwiazanieUmowyNieruchomosci from "./RozwiazanieUmowyNieruchomosci";
import PrzedluzenieUmowyNieruchomosci from "./PrzedluzenieUmowyNieruchomosci";
import UmowaNieruchomosci from "./UmowaNieruchomosci";
import Natura2000 from "./Natura2000";
import CzasoweZajeciePasa from "./CzasoweZajeciePasa";
import WykonanieZjazduZDrogi from "./WykonanieZjazduZDrogi";
import WydanieDecyzjiSrodowiskowej from "./WydanieDecyzjiSrodowiskowej";
import ZmianaWZULICP from "./ZmianaWZULICP";
import PrzeniesienieWZULICP from "./PrzeniesienieWZULICP";
import WniosekWZ from "./WniosekWZ";
import WniosekULICP from "./WniosekULICP";
import ZaswiadczenieOPrzeznaczeniu from "./ZaswiadczenieOPrzeznaczeniu";
import ZaswiadczenieRewitalizacja from "./ZaswiadczenieRewitalizacja";
import UsuniecieDrzewGminnych from "./UsuniecieDrzewGminnych";
import DzierzawaMiejscaGrzebalnego from "./DzierzawaMiejscaGrzebalnego";
import OplataZaDzierzaweMiejscaGrzebalnego from './OplataZaDzierzaweMiejscaGrzebalnego';
import ZgloszenieOczyszczalni from "./ZgloszenieOczyszczalni";
import OpiniaZgodnosciPodzialu from "./OpiniaZgodnosciPodzialu";
import DecyzjaPodzialu from "./DecyzjaPodzialu";
import ZgloszenieAwariiOsw from "./ZgloszenieAwariiOsw";
import RezerwacjaMiejscaNaCmentarzu from "./RezerwacjaMiejscaNaCmentarzu";
import UstaleniePomnikaOchronyPrzyrody from "./UstaleniePomnikaOchronyPrzyrody";
import ZgodaPrzeznaczenieGruntow from "./ZgodaPrzeznaczenieGruntow";
import UstNrPorz from './UstNrPorz';
import LoginWK from "./loginWK";
import LoginPZ from "./loginPZ";

const MainRoute = {
  path: "/",

  async action(req) {
    const list = {
      ZmianaMPZP,
      EServices,
      invest_contact: InvestContact,
      invest_contact_form: InvestContactForm,
      DecyzjeWZ,
      UsuniecieDrzew,
      DeklaracjaGrobu,
      SporzadzenieMPZP,
      ZezwolenieAlkohol,
      ZmianaCeluPublicznego,
      UstalenieNumeruPorzadkowego,
      OplataPlanistyczna,
      DecyzjeULICP,
      DecyzjaSrodowiskowa,
      ZaswiadczenieEMUIA,
      ServiceWMSWFS,
      ZmianaWarunkowZabudowy,
      ZmianaWZ,
      PrzeniesienieWZ,
      WnOpiniaPodzialu,
      ZgloszenieEwPOS,
      ZmianaSUIKZP,
      PrzeniesienieDecyzjiOWarunkachZabudowy,
      PrzeniesienieSrodowiskowychUwarunkowan,
      LudnoscMiejscowosc,
      LudnoscUlica,
      OdpadyInfo,
      DzierzawaNieruchomosci,
      OpiniaPodzialu,
      ZaswiadczenieFormOchrony,
      WniosekPomnikPrzyrody,
      UwagiProceduryPlanistycznej,
      SprzedazNieruchomosci,
      ZgodnoscMPZP,
      ZgodnoscBudowy,
      WniosekUproszczonyWypis,
      ZgloszeniePOS,
      LinkRedirector,
      WniosekMiejsceNaCmentarzu,
      PrzedlDzierBudGosp,
      PrzedDzierGrunty,
      DzierGruntRolnych,
      WykrHipoteki,
      PrzeniesienieCeluPublicznego,
      UzgodnienieBudowyOgrodzenia,
      ZwolnieniePasaDrogowego,
      NaliczenieOplatyRocznej,
      WniosekUzytkownikaWieczystego,
      ZajeciePasaDrogowego,
      PrzydzialLokaluMieszkalnego,
      SprzedazGruntuPodGaraz,
      SprzedazGruntuNaRzeczWUzytkownika,
      ZmianaAdrDoKorespondencji,
      NabycieNieruchomosciBezPrzetargu,
      ZbycieNieruchomosciWPrzetargu,
      OddanieNieruchomosci,
      RozgraniczenieNieruchomosci,
      DzierzawaGruntowRolnych,
      PrzeksztalceniePrawaUzytkowania,
      WydanieDecyzjiWZ,
      WydanieDecyzjiULICP,
      PrzekroczenieTonazu,
      PismoDoAktu,
      ObciazanieNieruchomosci,
      OplataRoczna,
      UwagaMPZP,
      DecyzjeWZiULICP,
      ZgloszenieUsunieciaDrzew,
      WydanieNagranZMonitoringu,
      ZbycieNieruchomosciKomunalnej,
      RozwiazanieUmowyNieruchomosci,
      PrzedluzenieUmowyNieruchomosci,
      UmowaNieruchomosci,
      Natura2000,
      CzasoweZajeciePasa,
      WykonanieZjazduZDrogi,
      WydanieDecyzjiSrodowiskowej,
      ZmianaWZULICP,
      PrzeniesienieWZULICP,
      WniosekWZ,
      WniosekULICP,
      ZaswiadczenieOPrzeznaczeniu,
      ZaswiadczenieRewitalizacja,
      UsuniecieDrzewGminnych,
      DzierzawaMiejscaGrzebalnego,
      OplataZaDzierzaweMiejscaGrzebalnego,
      UstNrPorz,
      CreatedEservice,
      ZgloszenieOczyszczalni,
      OpiniaZgodnosciPodzialu,
      DecyzjaPodzialu,
      ZgloszenieAwariiOsw,
      RezerwacjaMiejscaNaCmentarzu,
      UstaleniePomnikaOchronyPrzyrody,
      ZgodaPrzeznaczenieGruntow
    };

    const { query, store } = req;
    const state = store.getState();
    const service = state.district.eservices[query.serviceType];
    const { component, ...eservice } = service;
    let Component = list[component];
    const district = _.find(
      state.district.districts,
      (v) => v.teryt == query.district
    );

    if (!district.showOnList) {
      return {
        title: 'Nie znaleziono zasobu',
        component: <ServicesLayout><NotFound title={''} /></ServicesLayout>,
        status: 404,
      };
    }

    const isDisabled =
      district.disabledServices.indexOf(query.serviceType) >= 0;
    let props = { eservice };

    const { wkValid, pzValid } = await checkCertificates(district.teryt);

    const customTitle = eservice.custom_titles && eservice.custom_titles[district.prefix]? eservice.custom_titles[district.prefix] : null;
    if (customTitle) {
      eservice.title = customTitle;
    }

    if (eservice.requiresUserInfo) {
      // skipWkChecking - sposób na wejście do nowej gminy (np do testów lub prezentacji gdy nie mają certu WK)
      if ((!district.wkLogin || (district.wkLogin && !wkValid)) && !district.skipWkChecking) {
        return {
          title: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
          component: (
            <ServicesLayout prefix={district ? district.prefix : null}>
              <WKCertNotFound title={""} />
            </ServicesLayout>
          ),
          description: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
        };

      }

      // skipPzChecking - sposób na wejście do nowej gminy (np do testów lub prezentacji gdy nie mają certu PZ)
      if (eservice.requiresEPUAP && !pzValid && !district.skipPzChecking) {
        return {
          title: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
          component: (
            <ServicesLayout prefix={district ? district.prefix : null}>
              <EPUAPCertNotFound title={""} />
            </ServicesLayout>
          ),
          description: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
        };
      }

    }

    const mapState = await fetchMapState(query.district);

    // If service requires user info then fetch it
    if (eservice.requiresUserInfo) {
      if (state.user) {
        if (
          (!state.user.isConnectedToPZ || !state.user.IdZaufanegoProfilu) &&
          !state.user.isWkProfile
        ) {
          return { redirect: "/connectPZ" };
        }
        props = { ...props, user: { ...state.user, userType: "local" } };
      }
      else {
        if (!process.env.BROWSER) {
          return {
            title: "Wczytywanie",
            component: <LoginPZ wkLogin={district.wkLogin} />,
            description: "Widok wczytywania kontentu.",
          };
        } else {
          if (district.wkLogin) {
            return {
              title: "Logowanie wk",
              component: <LoginWK prefix={district.prefix} wkEnv={district.wkEnv} />,
              description: "Formularz z kontentem saml",
            };
          }
          window.location.replace(
            `${window.location.origin}/logowanieSAML?redirectUrl=${window.location.href}`,
          );
          return {
            title: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
            component: (
              <ServicesLayout
                prefix={district ? district.prefix : null}
              >
                <div>Wczytywanie...</div>
              </ServicesLayout>
            ),
            description: eservice.title,
          };
        }
      }
    }

    // If service requires map with precints then fetch them
    if (eservice.enablePrecints) {
      const precints = await fetchPrecints(query.district);
      props = { ...props, precints };
    }

    props.eservice.signWithEPUAP = false;
    props.eservice.confirmText = null;

    return {
      title: `${eservice.title} - Formularz - ${district ? district.name : ''} - e-spdp.pl`,
      component: (
        <ServicesLayout
          prefix={district ? district.prefix : null}
        >
          <Component
            prefix={district.prefix}
            serviceInfo={props}
            district={query.district}
            query={query}
            isDisabled={isDisabled}
            {...mapState}
          />
        </ServicesLayout>
      ),
      description: eservice.title,
    };
  },
};

export default {
  path: "/eservices",
  children: [
    MainRoute,
    require("../eserviceSummary").default,
    require("../paymentStatus").default,
  ],
};



// WEBPACK FOOTER //
// src/routes/eservices/index.js